import apiClient from './apiClient';

const API_BASE = process.env.REACT_APP_REPORTING_API_URL || 'http://localhost:8001/api/v1';

export const intelligentReportingAPI = {
  // Generate new report (synchronous — returns completed report)
  generateReport: async (query, outputFormat = 'html') => {
    const response = await apiClient.post(`${API_BASE}/ai/generate`, {
      query,
      output_format: outputFormat,
    });
    return response.data;
  },

  // Get report HTML content
  getReportHTML: async (reportId) => {
    const response = await apiClient.get(`${API_BASE}/ai/reports/${reportId}/html`);
    return response.data;
  },

  // Download PDF
  downloadPDF: async (reportId) => {
    const response = await apiClient.get(
      `${API_BASE}/ai/reports/${reportId}/pdf`,
      { responseType: 'blob' }
    );
    return response.data;
  },

  // Test query intent (preview)
  testIntent: async (query) => {
    const response = await apiClient.post(`${API_BASE}/ai/test-intent`, { query });
    return response.data;
  },
};
